module.exports = __webpack_public_path__ + "src/shared-components/icons/back-arrow.b3c1395205b945505ca238e067b4ee62.svg";